import { render, staticRenderFns } from "./topServe.vue?vue&type=template&id=30af2420&scoped=true"
import script from "./topServe.vue?vue&type=script&lang=ts"
export * from "./topServe.vue?vue&type=script&lang=ts"
import style0 from "./topServe.vue?vue&type=style&index=0&id=30af2420&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30af2420",
  null
  
)

export default component.exports